/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICittaPaymentInstrumentTabProps {
    isDisabled?: boolean;
    isChecked: boolean;
    imgSource?: string;
    imgHeight?: string;
    imgWidth?: string;
    labelString?: string;
    value: string;
    tabName: string;
    // tslint:disable-next-line:no-any
    handleKeyDown (e:any):void;
    // tslint:disable-next-line:no-any
    handleTabClick (e:any):void;
}

const CittaPaymentInstrumentTab = ({
    isDisabled,
    isChecked,
    imgSource,
    imgHeight,
    imgWidth,
    labelString,
    value,
    tabName,
    handleKeyDown,
    handleTabClick
}:ICittaPaymentInstrumentTabProps) => {
    return (
        <span tabIndex={0} role='tab' onKeyDown={handleKeyDown}>
            <input
                id={`${tabName}-tab`}
                className='payment-icon'
                type='radio'
                name={tabName}
                checked={isChecked}
                aria-checked={isChecked}
                value={value}
                onChange={handleTabClick}
                disabled={isDisabled}
            />
            <label htmlFor={`${tabName}-tab`}>
            <span className={`payment-label ${tabName}-tab`}>
                {imgSource && <img
                    src={imgSource}
                    alt={tabName}
                    height={imgHeight}
                    width={imgWidth}
                />}
                {!imgSource && labelString}
            </span>
            </label>
        </span>
    );
};

export default React.memo(CittaPaymentInstrumentTab);